"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntityByName = getEntityByName;
const organisation_entity_1 = require("../entities/organisation.entity");
const designation_entity_1 = require("../entities/designation.entity");
const department_entity_1 = require("../entities/department.entity");
const org_vertical_entity_1 = require("../entities/org-vertical.entity");
const org_branch_entity_1 = require("../entities/org-branch.entity");
const city_entity_1 = require("../entities/city.entity");
const state_entity_1 = require("../entities/state.entity");
const country_entity_1 = require("../entities/country.entity");
const region_entity_1 = require("../entities/region.entity");
const currency_entity_1 = require("../entities/currency.entity");
const entities_1 = require("../entities");
const user_1 = require("../entities/user");
function getEntityByName(name) {
    switch (name) {
        case "organisation": {
            return organisation_entity_1.Organisation;
        }
        case "designation": {
            return designation_entity_1.Designation;
        }
        case "department": {
            return department_entity_1.Department;
        }
        case "org_vertical": {
            return org_vertical_entity_1.OrgVertical;
        }
        case "org_branch": {
            return org_branch_entity_1.OrgBranch;
        }
        case "city": {
            return city_entity_1.City;
        }
        case "state": {
            return state_entity_1.State;
        }
        case "country": {
            return country_entity_1.Country;
        }
        case "region": {
            return region_entity_1.Region;
        }
        case "role": {
            return entities_1.Role;
        }
        case "currency": {
            return currency_entity_1.Currency;
        }
        case "user": {
            return user_1.User;
        }
        default:
            throw new Error(`Entity not found for table: ${name}`);
    }
}
